import { FC } from 'react';
import Icon from '../utils/Icon';
import Typography from '@carrot-deprecated/typography';
import Container from '@carrot-deprecated/container';

type Props = {
  value: {
    message: string;
    isError: boolean;
  } | null;
};

export const Feedback: FC<Props> = ({ value }) => {
  const { message, isError } = value ?? {};
  if (!message) {
    return null;
  }

  return (
    <Container flex gap="xs" alignItems="center" mt="s">
      <Icon
        icon={isError ? 'alert' : 'success'}
        fill={isError ? 'error' : 'success'}
      />
      <Typography variant="paragraph" color={isError ? 'error' : undefined}>
        {message}
      </Typography>
    </Container>
  );
};
